import * as tslib_1 from "tslib";
import * as findConversationShapeUtil from './utils/findConversationShapeUtil';
import findConversationRequest from 'owa-service/lib/factory/findConversationRequest';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import findConversationOperation from 'owa-service/lib/operation/findConversationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function configureRequestBody(currentFolderId, paging, viewFilter, sortResults, focusedViewFilter, categoryName, traversal, findConversationShapeName) {
    var folderId = currentFolderId;
    return findConversationRequest({
        ParentFolderId: targetFolderId({ BaseFolderId: currentFolderId }),
        ConversationShape: findConversationShapeUtil.getFindConversationResponseShape(folderId.Id),
        ShapeName: findConversationShapeName,
        Paging: paging,
        ViewFilter: viewFilter,
        SortOrder: sortResults,
        FocusedViewFilter: focusedViewFilter,
        CategoryFilter: categoryName,
        Traversal: traversal,
    });
}
export function findConversation(folderId, paging, viewFilter, sortResults, focusedViewFilter, findConversationShapeName, options, categoryName, traversal) {
    if (categoryName && viewFilter != 'UserCategory') {
        throw new Error('CategoryName should be set only for UserCategory view filter');
    }
    var requestOptions = tslib_1.__assign({}, options);
    // We are setting this flag to get the full Response object back from owa-service.
    requestOptions.returnFullResponseOnSuccess = true;
    var requestBody = configureRequestBody(folderId, paging, viewFilter, sortResults, focusedViewFilter, categoryName, traversal, findConversationShapeName);
    var result = findConversationOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }, requestOptions);
    return result;
}
//# sourceMappingURL=findConversation.js.map